/* eslint-disable prettier/prettier */
/** @jsxImportSource @emotion/react */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import { useFormik, Formik, Form } from "formik";
// import { Link } from "react-router-dom";
import * as Yup from "yup";
import { Box, Typography, Checkbox, IconButton, Modal } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { css, keyframes } from "@emotion/react";
import { Helmet } from "react-helmet";
// import { useNavigate } from "react-router-dom";
import Logo from "../../assets/svg/Logo";
import { INITIATE_LOGIN } from "../../redux/actionTypes/auth";
import Button from "../../components/common/Button/index";
import { ToastAlertContext } from "../../config/providers/ToastAlert";
import { AlertStatus } from "../../contants";
import InputField from "../../components/common/new/InputField/InputField";
import ShowPassword from "../../assets/svg/ShowPassword";
import HidePassword from "../../assets/svg/HidePasssword";
import TermsAndService from "./Modal/TermsAndConditionsModal";
import bdsLogin from "../../assets/images/bdsLogin.jpg";
import Forgot from "./forgotPassword";
import {
  startSessionTimer,
  clearSessionTimer,
} from "../../config/sessionManager";
import ForceLogout from "../../services/api/ForceLogout";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const wrapper = css`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background-image: url(${bdsLogin});
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
`;

const centerContainer = css`
  flex: 1;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 15px 155px;

  @media (max-width: 768px) {
    justify-content: center;
    padding: 16px;
  }
`;

const contentBox = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 465px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
  animation: ${fadeIn} 2s ease-out;
`;

const formSection = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

const footer = css`
  width: 100%;
  text-align: center;
  padding: 12px 0;
`;

const logoWrapper = css`
  display: flex;
  justify-content: center;
`;

const errorMessage = {
  color: "red",
  marginTop: 8,
  fontSize: "0.9rem",
};

function Login() {
  const TITLE = "Login - BSG";
  const [showPassword, setShowPassword] = useState(false);
  const [terms, setTerms] = useState(false);
  const [termsModal, setTermsModal] = useState(false);
  const [forgotModal, setForgotModal] = useState(false); // ✅ New state
  const dispatch = useDispatch();
  const loginError = useSelector((state) => state.auth.error);
  const toast = useContext(ToastAlertContext);
  // const navigate = useNavigate();

  const onLogout = async () => {
    console.log("🚨 onLogout triggered");

    const loginId = localStorage.getItem("loginId");

    if (loginId) {
      try {
        console.log("📡 Calling logout API before clearing session...");

        await ForceLogout.userLogout(loginId); // 👈 API CALL HERE

        console.log("🟢 Logout API success!");
      } catch (err) {
        // ✅ Stop timer
        clearSessionTimer();

        // ✅ Clear ALL storage
        localStorage.clear();
        sessionStorage.clear();

        // ✅ Force reload to login page
        window.location.href = "/";
        console.error("🔥 Logout API failed:", err);
      }
    }

    // ✅ Stop timer
    clearSessionTimer();

    // ✅ Clear ALL storage
    localStorage.clear();
    sessionStorage.clear();

    // ✅ Force reload to login page
    window.location.href = "/";
  };

  const onExtend = () => {
    console.log("🚨 Session extended triggered");
    clearSessionTimer();
    startSessionTimer(onLogout, onExtend);
    toast.show("Session extended", AlertStatus.SUCCESS);
  };

  const callLogoutApiAndClearSession = async () => {
    const loginId = localStorage.getItem("loginId");

    if (loginId) {
      try {
        console.log("📡 Calling logout API before clearing session...");
        await ForceLogout.userLogout(loginId);
        console.log("🟢 Logout API success!");
      } catch (err) {
        // 🔥 Session timers
        clearSessionTimer();

        // 🔥 Storage clear
        localStorage.clear();
        sessionStorage.clear();

        // 🔥 Redirect
        window.location.href = "/";
        console.error("🔥 Logout API failed:", err);
      }
    }

    // 🔥 Session timers बंद
    clearSessionTimer();

    // 🔥 Storage clear
    localStorage.clear();
    sessionStorage.clear();

    // 🔥 Redirect
    window.location.href = "/";
  };

  const formik = useFormik({
    initialValues: { memberId: "", password: "", portalName: "BDS_PORTAL" },
    validationSchema: Yup.object({
      memberId: Yup.string()
        .max(15, "Enter Member Id Less Than 15 character ")
        .required("BDS ID is required"),
      password: Yup.string()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters")
        .max(20, "Password must not exceed 20 characters"),
    }),
    onSubmit: (values) => {
      if (!terms) {
        toast.show(
          "Please agree with terms and conditions to proceed",
          AlertStatus.ERROR
        );
      } else {
        dispatch({ type: INITIATE_LOGIN, payload: values });
        startSessionTimer(
          // 🔴 onLogout handler → logout API + session clear
          async () => {
            await callLogoutApiAndClearSession();
          },

          // 🟢 onExtend handler
          () => {
            clearSessionTimer();

            startSessionTimer(
              // ⛔ Auto logout inside popup countdown
              async () => {
                toast.show(
                  "Session expired. Please login again.",
                  AlertStatus.ERROR
                );
                await callLogoutApiAndClearSession();
              },

              // 😀 Extend session
              () => {
                clearSessionTimer();
                startSessionTimer(onLogout, onExtend);
              }
            );

            toast.show("Session extended", AlertStatus.SUCCESS);
          }
        );

        // startSessionTimer(
        //   async () => {
        //     await callLogoutApiAndClearSession();
        //   },
        //   // 🔴 onLogout handler
        //   () => {
        //     clearSessionTimer();
        //     localStorage.clear();
        //     sessionStorage.clear();
        //     window.location.href = "/";
        //   },
        //   // 🟢 onExtend handler
        //   () => {
        //     clearSessionTimer();
        //     startSessionTimer(
        //       () => {

        //         async () => {
        //           toast.show(
        //             "Session expired. Please login again.",
        //             AlertStatus.ERROR
        //           );
        //           await callLogoutApiAndClearSession();
        //         },
        //         // clearSessionTimer();
        //         // localStorage.clear();
        //         // sessionStorage.clear();

        //         // // ✅ Force reload to login page
        //         // toast.show(
        //         //   "Session expired. Please login again.",
        //         //   AlertStatus.ERROR
        //         // );
        //         // navigate("/");
        //         // window.location.href = "/";
        //       // },
        //       () => {
        //         clearSessionTimer();
        //         startSessionTimer(onLogout, onExtend);
        //       }
        //     );
        //     toast.show("Session extended", AlertStatus.SUCCESS);
        //   }
        // );
      }
    },
  });

  useEffect(() => {
    document.body.style.overflow = "auto";
  }, []);

  useEffect(() => {
    if (loginError) {
      toast.show(
        loginError.message || "Invalid BDS ID/password.",
        AlertStatus.ERROR
      );
    }
  }, [loginError]);

  // useEffect(() => {
  //   if (window.botpressWebChat) return;

  //   const script1 = document.createElement("script");
  //   script1.src = "https://cdn.botpress.cloud/webchat/v3.5/inject.js";
  //   script1.async = true;

  //   script1.onload = () => {
  //     const script2 = document.createElement("script");
  //     script2.src =
  //       "https://files.bpcontent.cloud/2026/02/09/05/20260209054000-2KIGA9OL.js";
  //     script2.defer = true;

  //     document.body.appendChild(script2);
  //   };

  //   document.body.appendChild(script1);
  // }, []);

  const toggleTermsModal = () => setTermsModal((prev) => !prev);

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>{TITLE}</title>
      </Helmet>

      <Box css={wrapper}>
        <Box css={centerContainer}>
          <Box css={contentBox}>
            <Box css={formSection}>
              <Formik>
                <Form onSubmit={formik.handleSubmit} autoComplete="off">
                  <Box css={logoWrapper}>
                    <Logo width={80} height={70} />
                  </Box>
                  <Box textAlign="center" mb={3}>
                    <Typography
                      variant="h4"
                      sx={{ color: "#333", fontWeight: 700 }}
                    >
                      Welcome to BDS
                    </Typography>
                    <Typography sx={{ fontSize: 16, color: "#555", mt: 1 }}>
                      Please login to get started
                    </Typography>
                  </Box>

                  {/* Member ID Field */}
                  <Box mt={3}>
                    <Typography sx={{ fontSize: 15, fontWeight: 700, mb: 1 }}>
                      BDS ID
                    </Typography>
                    <InputField
                      type="text"
                      id="memberId"
                      name="memberId"
                      placeholder="Enter your BDS ID"
                      size="small"
                      onChange={formik.handleChange}
                      style={{ width: "100%", height: 48 }}
                    />
                    {formik.errors.memberId && formik.touched.memberId && (
                      <div style={errorMessage}>{formik.errors.memberId}</div>
                    )}
                  </Box>

                  {/* Password Field */}
                  <Box mt={4}>
                    <Typography sx={{ fontSize: 15, fontWeight: 700, mb: 1 }}>
                      Password
                    </Typography>
                    <InputField
                      type={showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      placeholder="Enter your password"
                      size="small"
                      onChange={formik.handleChange}
                      value={formik.values.password}
                      style={{ width: "100%", height: 48 }}
                      InputProps={{
                        endAdornment: (
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <ShowPassword /> : <HidePassword />}
                          </IconButton>
                        ),
                      }}
                    />
                    {formik.errors.password && formik.touched.password && (
                      <div style={errorMessage}>{formik.errors.password}</div>
                    )}
                  </Box>

                  {/* Forgot Password Link (modal trigger) */}
                  <Box textAlign="left" mt={1}>
                    <Typography
                      onClick={() => setForgotModal(true)}
                      sx={{
                        color: "#00449E",
                        fontSize: 14,
                        fontWeight: 500,
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      Forgot Password?
                    </Typography>
                  </Box>

                  {/* Terms & Conditions */}
                  <Box mt={6}>
                    <Box display="flex" alignItems="flex-start">
                      <Checkbox
                        name="terms"
                        id="terms"
                        checked={terms}
                        onChange={(e) => setTerms(e.target.checked)}
                        sx={{ p: 0, mr: 2 }}
                      />
                      <Typography sx={{ fontSize: 14, color: "#555" }}>
                        I agree to the{" "}
                        <Typography
                          component="span"
                          onClick={toggleTermsModal}
                          sx={{
                            color: "#00449E",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}
                        >
                          Terms of Service and Privacy Policy
                        </Typography>
                      </Typography>
                    </Box>
                  </Box>

                  {/* Submit Button */}
                  <Box mt={4}>
                    <Button
                      type="submit"
                      variant="contained"
                      size="medium"
                      style={{
                        textTransform: "uppercase",
                        width: "100%",
                        height: "41px",
                      }}
                      label=" Login"
                    />
                  </Box>

                  {/* ✅ QRScanner Link */}
                  {/* <Box textAlign="center" mt={2}>
                    <Link
                      to="/qr-attendance-login"
                      style={{
                        color: "#00449E",
                        fontSize: "14px",
                        fontWeight: 500,
                        textDecoration: "underline",
                      }}
                    >
                      Qr Attendance Login
                    </Link>
                  </Box> */}
                </Form>
              </Formik>

              <TermsAndService open={termsModal} onClose={toggleTermsModal} />
            </Box>
          </Box>
        </Box>

        {/* Footer */}
        <Box css={footer}>
          <Typography
            variant="caption"
            color="#ffffff"
            component="div"
            dangerouslySetInnerHTML={{
              __html: "©Copyright Bharat Soka Gakkai 2026",
            }}
          />
        </Box>
      </Box>

      {/* Forgot Password Modal */}
      <Modal
        open={forgotModal}
        onClose={() => setForgotModal(false)}
        aria-labelledby="forgot-password-modal"
        aria-describedby="forgot-password-modal-description"
        sx={{ overflow: "auto" }}
      >
        <Box
          sx={{
            margin: "5% auto",
            maxWidth: "700px",
            outline: "none",
            position: "relative",
          }}
        >
          <Forgot onClose={() => setForgotModal(false)} />
        </Box>
      </Modal>
    </>
  );
}

export default Login;
